module.exports = __webpack_public_path__ + "img/gsv.284fb906.png";